import { mountStoreDevtool } from 'simple-zustand-devtools';
import { create } from 'zustand';

import { DigitalVisitReasonEnum } from '@src/lib/__generated/api';

export type State = {
	reasonForVisit: DigitalVisitReasonEnum | '';
	hasReasonForVisit: boolean;
};

type Actions = {
	setReasonForVisit: (reasonForVisit: DigitalVisitReasonEnum) => void;
	setHasReasonForVisit: (hasReasonForVisit: boolean) => void;
};

const useReasonForVisitStore = create<State & Actions>((set) => ({
	reasonForVisit: '',
	setReasonForVisit: (reasonForVisit) => set({ reasonForVisit }),
	hasReasonForVisit: false,
	setHasReasonForVisit: (hasReasonForVisit) => set({ hasReasonForVisit }),
}));

if (process.env.NODE_ENV === 'development') {
	mountStoreDevtool('reasonForVisitStore', useReasonForVisitStore);
}

export default useReasonForVisitStore;
